class FacetDrawer extends MainDrawer {
  constructor() {
    super();

    this.trigger = this.querySelector('.drawer__trigger');
    if (this.trigger) {
      this.trigger.addEventListener('click', () => this.loadAssets());
    }
  }

  loadAssets() {
    if (!document.getElementById('FACETSCSS') && !document.getElementById('FACETSJS')) {
      this.classList.add('loading');
    }

    loadCss('facets')
      .then(() => {
        setTimeout(() => {
          this.classList.remove('loading');
        }, 300);
      })
      .catch((error) => {
        console.error(error);
      });
    loadScript('facets').catch((error) => {
      console.error(error);
    });
    this.openDrawer();
  }
}
customElements.define('facet-drawer', FacetDrawer);


document.addEventListener('DOMContentLoaded', function() {
  const verticalFacets = document.querySelector('.facet--vertical--desktop');
  const mobile = document.querySelector('aside .facet--vertical');
  const mq = window.matchMedia('(max-width: 768px)');
  function syncFilters() {
    if (mq.matches) {
      // Mobile: remove desktop
      verticalFacets && verticalFacets.parentNode && verticalFacets.parentNode.removeChild(verticalFacets);
    } else {
      // Desktop: remove mobile
      mobile && mobile.parentNode && mobile.parentNode.removeChild(mobile);
    }
  }
  syncFilters();
  // Reload only when crossing the 768px breakpoint (e.g. rotating a tablet),
  // not on every resize — mobile browsers fire resize when the URL bar
  // collapses during scroll, which was reloading the page back to the top.
  mq.addEventListener('change', () => window.location.reload());
});
